<div class="tasks_table1 ">
    <div class="row">
        <div class="col-md-10 search-box">
            <label style="width: 100%;"><span><input type="text" id="search" class="custom-focus-input"
                autocomplete="off" [placeholder]="placeholderText"
                 style="height: 37px;border: none;width: 115.2%;margin-left: 14px;"
                (input)="searchSubCategory($event)"></span></label>
            </div>
        <div class="col-md-2" (click)="addSubpop()" style="padding: 8px;text-align: center;">
            <button class=" hand add"
                onclick="document.getElementById('subCategoryModal').style.display='block'">+
            </button>
        </div>
    </div>

</div>
<table class="table table-striped">
<thead class="tablehd-sec">
    <tr>
        <th style="width: 10%;">Sr. No</th>
        <th style="width: 20%;">Near By Category</th>
        <th style="width: 30%;">Near By Sub Category Keyword</th>
        <th style="width: 30%;">Near By Sub Category Urls</th>
        <th style="width: 10%;">Action</th>
    </tr>
</thead>
<tbody>
    <tr *ngFor="let d of allNearBySubServices| paginate: { itemsPerPage: 10, currentPage: p};let i = index"
        class="tdata">
        <td style="width: 10%;" class="padleft-30">
          {{i+1}}
        </td>
        <td style="width: 20%;">
            {{getMainCategoryName(d.nearByServiceCategoryId)}}
        </td>
        <td style="width: 30%;">
            {{d.nearByServiceSubCategoryKeyword}}
        </td>
        <td style="width: 30%;">
            {{d.nearByServiceSubCategoryUrl}}
        </td>
        <td style="width: 10%;">
            <i (click)="updateSubpop(d)" class="fa fa-pencil thclr bl hand"
                style="margin-right: 10px;"
                onclick="document.getElementById('subCategoryModal').style.display='block'"></i>
            <i class="fa fa-trash-o hand dangr" style="font-size: 20px; margin-right: 10px;"
               (click)="selectedSubService(d)"
               onclick="document.getElementById('SubDeleteModal').style.display='block'"></i>
        </td>
    </tr>
</tbody>
</table>
<div class="row">
<div class="col">
    <div class="d-flex justify-content-center" *ngIf="allNearBySubServices.length!=0">
        <pagination-controls (pageChange)="pageChanged($event)"
            (pageBoundsCorrection)="pageChanged($event)">
        </pagination-controls>
    </div>
</div>
</div>
<div class="modal" id="subCategoryModal" style="overflow: hidden;padding-top: 50px;">
    <div class="modal-content" style="width: 30%;">
        <div class="modal-header" style="padding-top: 0;">
            <h4 class="modal-title text-center" id="myModalLabel" *ngIf="subModal == 'subAddModal'">Near By Sub Category</h4>
            <h4 class="modal-title text-center" id="myModalLabel" *ngIf="subModal == 'subUpdateModal'">Update Near By Sub Category</h4>
            <span onclick="document.getElementById('subCategoryModal').style.display='none'" class="close hand"
                title="Close Modal">×</span>
        </div>
        <div class="modal-body" style="padding-bottom: 0;">
            <div class="row">
                <label style="padding: 0;">Near By Category<span style="color: red;">*</span></label>
                <select class="form-control" [(ngModel)]="selectedCategoryId" (change)="selectedServiceForSubService()">
                    <option value="0" disabled>Select Service</option>
                    <option *ngFor="let service of allNearByServices" [value]="service.nearByServiceCategoryId">{{ service.nearByServiceCategory }}</option>
                </select>                  
            </div>

            <div class="row" >
                <label style="padding: 0; margin-top: 12px">Near By Sub Category Keyword<span style="color: red;">*</span></label>
                <input *ngIf="subModal == 'subUpdateModal'" type="text" class="form-control" [(ngModel)]="newSubServiceKeyword" placeholder="Update near by sub category keyword">
                <input *ngIf="subModal == 'subAddModal'" type="text" class="form-control" [(ngModel)]="newSubServiceKeyword" placeholder="Add near by sub category keyword">
            </div>
            
            <div class="row" >
                <label style="padding: 0; margin-top: 12px;">Near By Sub Category Url<span style="color: red;">*</span></label>
                <input *ngIf="subModal == 'subUpdateModal'" type="text" class="form-control" [(ngModel)]="newSubServiceUrl" placeholder="Update near by sub category url">
                <input *ngIf="subModal == 'subAddModal'" type="text" class="form-control" [(ngModel)]="newSubServiceUrl" placeholder="Add near by sub category url">
            </div>
            
            <div class="row mrt-20" style="display: flex;">
                <button class="save hand" (click)="addNearBySubService()" *ngIf="subModal == 'subAddModal'"
                onclick="document.getElementById('subCategoryModal').style.display='none'">Save</button>
                <button class="save hand" (click)="updateNearBySubService()" *ngIf="subModal == 'subUpdateModal'"
                onclick="document.getElementById('subCategoryModal').style.display='none'">Update</button>
                <button class="save hand" style="background-color: #d9534f;" onclick="document.getElementById('subCategoryModal').style.display='none'">Cancel</button>
            </div>

        </div>

    </div>

</div>
<div id="SubDeleteModal" class="modal" style="overflow: hidden;" >

    <form class="modal-content" style="width: 35%;">
        <div class="container">
            <div class="modal-header" style="padding-top: 0;">
                <h5 class="modal-title" id="exampleModalLabel" style="margin-left: auto;">Confirm</h5>
                <button type="button" id="dismissModal"
                    onclick="document.getElementById('SubDeleteModal').style.display='none'" class="btn-close"
                    data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div style="padding-top: 15px;
            padding-bottom: 15px; text-align: center;">
                <p>Are you sure, you want to delete </p>
                <p> <b>{{selectedSubServiceKeyword}}</b> ?</p>
            </div>
            <div class="modal-footer" style="padding-bottom: 0;">
                <button type="button" onclick="document.getElementById('SubDeleteModal').style.display='none'"
                    class="btn btn-danger footer-button ml-auto" data-bs-dismiss="modal"
                    style="width: 18%;margin-left: auto;">Cancel</button>
                <button type="button" class="btn btn-primary footer-button mr-auto" (click)="deleteNearBySubService(selectedSubCategoryId)"
                    style="width: 18%;margin-right: auto;" onclick="document.getElementById('SubDeleteModal').style.display='none'">Delete</button>
            </div>
        </div>
    </form>
</div>